import Loadable from 'react-loadable';
import Loader from './containers/Loader';
import { authorizedPages } from './config/roles';

export var siteTitle = 'TCL';
if(localStorage.getItem('country')=="sa" ){
    siteTitle="Field Engineer"
}else{
    siteTitle="Field Engineer"
}
export const siteMetaDescription = 'Tata Communications';

export const setTitle = (title) =>{
    document.title = (title)?title:siteTitle;
}

export const setMetaDescription = (description) => {
    document.querySelector('meta[name="description"]').setAttribute("content", (description)?description:siteMetaDescription);
}
/**
 * List of routes for the page
 */
export const ROUTE = [
    {
        private: false,
        exact: true,
        path: '/',
        meta:{
            title: siteTitle,
            description: siteMetaDescription,
        },
        component: Loadable({
            loader: () => import ('./containers/Login'),
            loading: Loader,
        })
    },
    {
        private: false,
        exact: true,
        path: '/oss',
        meta:{
            title: siteTitle,
            description: siteMetaDescription,
        },
        component: Loadable({
            loader: () => import ('./containers/privicy'),
            loading: Loader,
        })
    },
    {
        private: true,
        exact: true,
        path: '/access/denied',
        meta:{
            title: siteTitle,
            description: siteMetaDescription,
        },
        component: Loadable({
            loader: () => import ('./components/error/AccessDenied'),
            loading: Loader,
        })
    },
    {
        private: true,
        exact: true,
        path: '/users',
        permission: authorizedPages.users.view,
        meta:{
            title: siteTitle,
            description: siteMetaDescription,
        },
        component: Loadable({
            loader: () => import ('./containers/Users'),
            loading: Loader,
        })
    } ,
    {
        private: true,
        exact: true,
        path: '/grid',
        meta:{
            title: siteTitle,
            description: siteMetaDescription,
        },
        component: Loadable({
            loader: () => import ('./containers/Grid'),
            loading: Loader,
        })
    },
    {
        private: true,
        exact: true,
        path: '/users/add',
        permission: authorizedPages.users.create,
       component: Loadable({
           loader: () => import ('./containers/Users/add'),
            loading: Loader,
        })
   },
     {
        private: true,
        exact: true,
        path: '/devices',
        permission: authorizedPages.devices.view,
        meta:{
            title: siteTitle,
            description: siteMetaDescription,
        },
        component: Loadable({
            loader: () => import ('./containers/Devices'),
            loading: Loader,
        })
     },
     {
        private: true,
        exact: true,
        path: '/devices/add',
        permission: authorizedPages.devices.create,
        meta:{
            title: siteTitle,
            description: siteMetaDescription,
        },
        component: Loadable({
            loader: () => import ('./containers/Devices/Add'),
            loading: Loader,
        })
     },
     {
        private: true,
        exact: true,
        path: '/devices/edit/:deviceId',
        permission: authorizedPages.devices.edit,
        meta:{
            title: siteTitle,
            description: siteMetaDescription,
        },
        component: Loadable({
            loader: () => import ('./containers/Devices/Edit'),
            loading: Loader,
        })
     },
     {
        private: true,
        exact: true,
        path: '/devicehistory/edit/:installId',
        permission: authorizedPages.deviceInstallationReport.edit,
        meta:{
            title: siteTitle,
            description: siteMetaDescription,
        },
        component: Loadable({
            loader: () => import ('./containers/DeviceHistory/Edit'),
            loading: Loader,
        })
     },
     {
        private: true,
        exact: true,
        path: '/devices/inventories',
        meta:{
            title: siteTitle,
            description: siteMetaDescription,
        },
        component: Loadable({
            loader: () => import ('./containers/Devices/Inventories'),
            loading: Loader,
        })
     },
     {
        private: true,
        exact: true,
        path: '/devicemapping',
        meta:{
            title: siteTitle,
            description: siteMetaDescription,
        },
        component: Loadable({
            loader: () => import ('./containers/Devices/Allocation'),
            loading: Loader,
        })
     },
     {
        private: true,
        exact: true,
        path: '/feedermapping',
        meta:{
            title: siteTitle,
            description: siteMetaDescription,
        },
        component: Loadable({
            loader: () => import ('./containers/Feeder/Allocation'),
            loading: Loader,
        })
     },
    
   
     {
        private: true,
        exact: true,
        path: '/roles',
        permission: authorizedPages.rolePermission.view,
        meta:{
            title: siteTitle,
            description: siteMetaDescription,
        },
        component: Loadable({
            loader: () => import ('./containers/RoleAndPermission/'),
            loading: Loader,
        })
     },
     {
        private: true,
        exact: true,
        path: '/assignrole/:id',
        permission: authorizedPages.rolePermission.view,
        meta:{
            title: siteTitle,
            description: siteMetaDescription,
        },
        component: Loadable({
            loader: () => import ('./containers/RoleAndPermission/Assignrole'),
            loading: Loader,
        })
     },
     {
        private: false,
        exact: true,
        path: '/forgot/password',
        meta:{
            title: siteTitle,
            description: siteMetaDescription,
        },
        component: Loadable({
            loader: () => import ('./containers/Forgotpassword'),
            loading: Loader,
        })
     },
     {
        private: true,
        exact: true,
        path: '/grid/new',
        meta:{
            title: siteTitle,
            description: siteMetaDescription,
        },
        component: Loadable({
            loader: () => import ('./containers/Grid/GridNew'),
            loading: Loader,
        })
     },
     {
        private: false,
        exact: true,
        path: '/reset/password/:id',
        meta:{
            title: siteTitle,
            description: siteMetaDescription,
        },
        component: Loadable({
            loader: () => import ('./containers/Resetpassword'),
            loading: Loader,
        })
     },
     {
        private: true,
        exact: true,
        path: '/customers/add',
        permission: authorizedPages.customers.create,
        meta:{
            title: siteTitle,
            description: siteMetaDescription,
        },
        component: Loadable({
            loader: () => import ('./containers/Customers/add'),
            loading: Loader,
        })
     },
     {
        private: true,
        exact: true,
        path: '/customers/edit/:id',
        permission: authorizedPages.customers.edit,
        meta:{
            title: siteTitle,
            description: siteMetaDescription,
        },
        component: Loadable({
            loader: () => import ('./containers/Customers/edit'),
            loading: Loader,
        })
     },
     {
        private: true,
        exact: true,
        path: '/customers',
        permission: authorizedPages.customers.view,
        meta:{
            title: siteTitle,
            description: siteMetaDescription,
        },
        component: Loadable({
            loader: () => import ('./containers/Customers'),
            loading: Loader,
        })
     },
     {
        private: true,
        exact: true,
        path: '/users/edit/:id',
        permission: authorizedPages.users.edit,
        meta:{
            title: siteTitle,
            description: siteMetaDescription,
        },
        component: Loadable({
            loader: () => import ('./containers/Users/edit'),
            loading: Loader,
        })
     },
     {
        private: true,
        exact: true,
        path: '/smstemplates',
        permission: authorizedPages.smsTemplate.view,
        meta: {
            title: siteTitle,
            description: siteMetaDescription,
        },
        component: Loadable({
            loader: () => import('./containers/EmailSms/SmsTemplate'),
            loading: Loader,
        })
    },
    {
        private: true,
        exact: true,
        path: '/smstemplates/add',
        permission: authorizedPages.smsTemplate.view,
        meta: {
            title: siteTitle,
            description: siteMetaDescription,
        },
        component: Loadable({
            loader: () => import('./containers/EmailSms/SmsTemplate/add'),
            loading: Loader,
        })
    },
    {
        private: true,
        exact: true,
        path: '/smstemplates/edit/:id',
        permission: authorizedPages.smsTemplate.edit,
        meta: {
            title: siteTitle,
            description: siteMetaDescription,
        },
        component: Loadable({
            loader: () => import('./containers/EmailSms/SmsTemplate/edit'),
            loading: Loader,
        })
    },
    
     {
        private: true,
        exact: true,
        path: '/addressmasterdata/add',
        permission: authorizedPages.addressManagement.create,
        meta:{
            title: siteTitle,
            description: siteMetaDescription,
        },
        component: Loadable({
            loader: () => import ('./containers/AddressMasterData/Add'),
            loading: Loader,
        })
     },
     {
        private: true,
        exact: true,
        path: '/addressmasterdata',
        permission: authorizedPages.addressManagement.view,
        meta:{
            title: siteTitle,
            description: siteMetaDescription,
        },
        component: Loadable({
            loader: () => import ('./containers/AddressMasterData/index'),
            loading: Loader,
        })
     },
     {
        private: true,
        exact: true,
        path: '/poles/add',
        permission: authorizedPages.poleManagement.create,
        meta:{
            title: siteTitle,
            description: siteMetaDescription,
        },
        component: Loadable({
            loader: () => import ('./containers/Pole/add'),
            loading: Loader,
        })
     },
     {
        private: true,
        exact: true,
        path: '/poles/edit/:id',
        permission: authorizedPages.poleManagement.edit,
        meta:{
            title: siteTitle,
            description: siteMetaDescription,
        },
        component: Loadable({
            loader: () => import ('./containers/Pole/edit'),
            loading: Loader,
        })
     },
     {
       private: true,
       exact: true,
       path: '/poles',
       permission: authorizedPages.poleManagement.view,
       meta:{
         title: siteTitle,
         description: siteMetaDescription,
       },
       component: Loadable({
         loader: () => import ('./containers/Pole/index'),
         loading: Loader,
       })
     },
     {
        private: true,
        exact: true,
        path: '/ledLoads/add',
        permission: authorizedPages.ledloadManagement.create,
        meta:{
            title: siteTitle,
            description: siteMetaDescription,
        },
        component: Loadable({
            loader: () => import ('./containers/LEDLoad/add'),
            loading: Loader,
        })
     },
     {
        private: true,
        exact: true,
        path: '/ledLoads/edit/:id',
        permission: authorizedPages.ledloadManagement.edit,
        meta:{
            title: siteTitle,
            description: siteMetaDescription,
        },
        component: Loadable({
            loader: () => import ('./containers/LEDLoad/edit'),
            loading: Loader,
        })
     },
     {
       private: true,
       exact: true,
       path: '/ledLoads',
       permission: authorizedPages.ledloadManagement.view,
       meta:{
         title: siteTitle,
         description: siteMetaDescription,
       },
       component: Loadable({
         loader: () => import ('./containers/LEDLoad/index'),
         loading: Loader,
       })
     },
     {
        private: true,
        exact: true,
        path: '/lamps',
        permission: authorizedPages.lampManagement.view,
        meta:{
            title: siteTitle,
            description: siteMetaDescription,
        },
        component: Loadable({
            loader: () => import ('./containers/Lamp/index'),
            loading: Loader,
        })
     },
     {
        private: true,
        exact: true,
        path: '/lamps/add',
        permission: authorizedPages.lampManagement.create,
        meta:{
            title: siteTitle,
            description: siteMetaDescription,
        },
        component: Loadable({
            loader: () => import ('./containers/Lamp/add'),
            loading: Loader,
        })
     },
     {
        private: true,
        exact: true,
        path: '/lamps/edit/:id',
        permission: authorizedPages.lampManagement.edit,
        meta:{
            title: siteTitle,
            description: siteMetaDescription,
        },
        component: Loadable({
            loader: () => import ('./containers/Lamp/edit'),
            loading: Loader,
        })
     },
     {
        private: true,
        exact: true,
        path: '/feeders',
        permission: authorizedPages.feederManagement.view,
        meta:{
            title: siteTitle,
            description: siteMetaDescription,
        },
        component: Loadable({
            loader: () => import ('./containers/Feeder/index'),
            loading: Loader,
        })
     },
     {
        private: true,
        exact: true,
        path: '/feeders/add',
        permission: authorizedPages.feederManagement.create,
        meta:{
            title: siteTitle,
            description: siteMetaDescription,
        },
        component: Loadable({
            loader: () => import ('./containers/Feeder/add'),
            loading: Loader,
        })
     },
     {
        private: true,
        exact: true,
        path: '/feeders/edit/:id',
        permission: authorizedPages.feederManagement.edit,
        meta:{
            title: siteTitle,
            description: siteMetaDescription,
        },
        component: Loadable({
            loader: () => import ('./containers/Feeder/feederEdit'),
            loading: Loader,
        })
     },
     {
        private: true,
        exact: true,
        path: '/feederpole/edit/:id',
        permission: authorizedPages.feederManagement.edit,
        meta:{
            title: siteTitle,
            description: siteMetaDescription,
        },
        component: Loadable({
            loader: () => import ('./containers/Feeder/poleEdit'),
            loading: Loader,
        })
     },
     {
        private: true,
        exact: true,
        path: '/reports/deviceinstallation',
        meta:{
            title: siteTitle,
            description: siteMetaDescription,
        },
        component: Loadable({
            loader: () => import ('./containers/Reports/DeviceInstallation'),
            loading: Loader,
        })
     },
     {
        private: true,
        exact: true,
        path: '/reports/feederinstallation',
        meta:{
            title: siteTitle,
            description: siteMetaDescription,
        },
        component: Loadable({
            loader: () => import ('./containers/Reports/FeederInstallation'),
            loading: Loader,
        })
     },
     {
        private: false,
        exact: true,
        path: "/update/password",
        meta: {
            title: siteTitle,
            description: siteMetaDescription
        },
        component: Loadable({
            loader: () => import("./containers/UpdatePassword"),
            loading: Loader
    })
  },
    {
       private: true,
       exact: true,
       path: '/change/password',
       meta:{
           title: siteTitle,
           description: siteMetaDescription,
       },
       component: Loadable({
           loader: () => import ('./containers/Users/ChangePassword'),
           loading: Loader,
       })
    },
    {
       private: true,
       exact: true,
       path: '/settings',
       meta:{
           title: siteTitle,
           description: siteMetaDescription,
       },
       component: Loadable({
           loader: () => import ('./containers/Settings'),
           loading: Loader,
       })
    },
    {
       private: true,
       exact: true,
       path: '/products/add',
       permission: authorizedPages.products.create,
       meta:{
           title: siteTitle,
           description: siteMetaDescription,
       },
       component: Loadable({
           loader: () => import ('./containers/Products/add'),
           loading: Loader,
       })
    },
    {
       private: true,
       exact: true,
       path: '/products/edit/:id',
       permission: authorizedPages.products.edit,
       meta:{
           title: siteTitle,
           description: siteMetaDescription,
       },
       component: Loadable({
           loader: () => import ('./containers/Products/edit'),
           loading: Loader,
       })
    },
    {
       private: true,
       exact: true,
       path: '/products',
       permission: authorizedPages.products.view,
       meta:{
           title: siteTitle,
           description: siteMetaDescription,
       },
       component: Loadable({
           loader: () => import ('./containers/Products'),
           loading: Loader,
       })
    },
    {
       private: true,
       exact: true,
       path: '/projects/add',
       permission: authorizedPages.projects.create,
       meta:{
           title: siteTitle,
           description: siteMetaDescription,
       },
       component: Loadable({
           loader: () => import ('./containers/Projects/add'),
           loading: Loader,
       })
    },
    {
       private: true,
       exact: true,
       path: '/projects/edit/:id',
       permission: authorizedPages.projects.edit,
       meta:{
           title: siteTitle,
           description: siteMetaDescription,
       },
       component: Loadable({
           loader: () => import ('./containers/Projects/edit'),
           loading: Loader,
       })
    },
    {
       private: true,
       exact: true,
       path: '/projects',
       permission: authorizedPages.projects.view,
       meta:{
           title: siteTitle,
           description: siteMetaDescription,
       },
       component: Loadable({
           loader: () => import ('./containers/Projects'),
           loading: Loader,
       })
    },
    {
        private: true,
        exact: true,
        path: '/property/add',
        permission: authorizedPages.projects.create,
        meta:{
            title: siteTitle,
            description: siteMetaDescription,
        },
        component: Loadable({
            loader: () => import ('./containers/Property/Add'),
            loading: Loader,
        })
     },
     {
        private: true,
        exact: true,
        path: '/property/edit/:id',
        permission: authorizedPages.projects.edit,
        meta:{
            title: siteTitle,
            description: siteMetaDescription,
        },
        component: Loadable({
            loader: () => import ('./containers/Property/Edit'),
            loading: Loader,
        })
     },
     {
        private: true,
        exact: true,
        path: '/property',
        permission: authorizedPages.projects.view,
        meta:{
            title: siteTitle,
            description: siteMetaDescription,
        },
        component: Loadable({
            loader: () => import ('./containers/Property'),
            loading: Loader,
        })
     },
     {
        private: true,
        exact: true,
        path: '/firmwares',
        permission: authorizedPages.firmware.view,
        meta:{
            title: siteTitle,
            description: siteMetaDescription,
        },
        component: Loadable({
            loader: () => import ('./containers/firmwares'),
            loading: Loader,
        })
     },
     {
        private: true,
        exact: true,
        path: '/firmwares/add',
        permission: authorizedPages.firmware.create,
        meta:{
            title: siteTitle,
            description: siteMetaDescription,
        },
        component: Loadable({
            loader: () => import ('./containers/firmwares/Add'),
            loading: Loader,
        })
     },
     {
        private: true,
        exact: true,
        path: '/firmwares/edit/:deviceId',
        permission: authorizedPages.firmware.edit,
        meta:{
            title: siteTitle,
            description: siteMetaDescription,
        },
        component: Loadable({
            loader: () => import ('./containers/firmwares/Edit'),
            loading: Loader,
        })
     },
     {
        private: true,
        exact: true,
        path: '/reports/firmware/updates',
        permission: authorizedPages.firmwareUpdateReport.view,
        meta:{
            title: siteTitle,
            description: siteMetaDescription,
        },
        component: Loadable({
            loader: () => import ('./containers/Reports/FirmwareInstallation'),
            loading: Loader,
        })
     },
];
